import { InjectorService } from '@tencent/ioc';

/**
 * Adapter 装饰器，用于声明一个新的编辑器 Adapter。
 * 所有用 `@Adapter()` 注解的类均在同一时间被初始化
 *
 * @public
 *
 * @param options - Adapter 名称或其配置
 *
 * @remarks
 * ### Example
 *
 * 下面例子中展示如何创建一个 SlateEditor 适配器
 *
 * ```typescript
 * import { Adapter, Workbench } from '@tencent/workbench';
 * import { SlateEditor } from './slate';
 *
 * @Adapter('slate')
 * export class SlateAdapter implements IAdapter<SlateEditor> {
 *    async attachEditor(element: HTMLElement, callbacks) {
 *        return new Promise<SlateEditor>((resolve) => {
 *            let editor!: SlateEditor;
 *            const component = <SlateEditor ref={((instance) => { editor = instance!; })}/>;
 *            ReactDOM.render(component, element, () => {
 *                resolve(editor);
 *                this.setCallbacks(editor, callbacks);
 *            });
 *        });
 *    }
 *
 *    setValue(editor: SlateEditor, value: Value) {
 *        editor.setValue(value);
 *    }
 *
 *    setCallbacks(editor: SlateEditor, callbacks: IAdapterCallback) {
 *        editor.addPlugins([
 *            {
 *                onBlur: (event, slate, next) => {
 *                    callbacks.onBlur();
 *                    return next();
 *                },
 *                onFocus: (event, slate, next) => {
 *                    callbacks.onFocus();
 *                    return next();
 *                },
 *            },
 *        ]);
 *    }
 *
 *    requestFocus() {
 *
 *    }
 * }
 *
 * const workbench = new Workbench();
 * workbench.adapt([SlateAdapter]);
 * ```
 *
 * @decorator
 */
function Adapter(options) {
    return ((target) => {
        var _a;
        let adapterName;
        if (typeof options === 'string') {
            adapterName = options;
            InjectorService.service(target, { type: 'adapter' });
        }
        else {
            adapterName = options.name;
            InjectorService.set({
                provide: (_a = options.token) !== null && _a !== void 0 ? _a : target,
                useClass: target,
                singleton: true,
                type: 'adapter',
            });
        }
        target.prototype.toString = () => adapterName;
        InjectorService.service(target, { type: 'adapter' });
        InjectorService.invokable(target);
        return target;
    });
}

export { Adapter };
//# sourceMappingURL=adapter.js.map
